var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 14.9993H9.35M16 14.9993H16.0167M22.6667 14.9993H22.6833M31 14.9993C31 22.3627 24.2833 28.3327 16 28.3327C13.5477 28.341 11.1247 27.8006 8.90833 26.751L1 28.3327L3.325 22.1327C1.85333 20.0693 1 17.6227 1 14.9993C1 7.63601 7.71667 1.66602 16 1.66602C24.2833 1.66602 31 7.63601 31 14.9993Z",
    stroke: "#CE2600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5ed827c409962b2a632e8d0552d8f636.svg";
export { ForwardRef as ReactComponent };